import React from "react";
import { CheckCircle2, Film, Loader2, Plus } from "lucide-react";
import { assetUrl } from "../../lib/api";
import { secs } from "../../hooks/useVideoStudio";

const Item = ({ v, active, onClick }) => (
  <button onClick={onClick} data-testid={`video-lib-item-${v.id}`}
    className={`shrink-0 md:w-full w-52 flex items-center gap-2.5 p-2 rounded-lg text-left transition-colors ${active ? "bg-white shadow-sm ring-1 ring-slate-200" : "hover:bg-white/70"}`}>
    <span className="w-14 h-9 rounded-md bg-slate-200 overflow-hidden flex items-center justify-center shrink-0">
      {v.thumb_url ? <img src={assetUrl(v.thumb_url)} alt="" className="w-full h-full object-cover" /> : <Film size={14} className="text-slate-400" />}
    </span>
    <span className="min-w-0 flex-1">
      <span className="block text-xs font-medium text-slate-800 truncate">{v.name}</span>
      <span className="flex items-center gap-1 text-[10px] text-slate-500">
        {v.busy ? <><Loader2 size={10} className="animate-spin text-emerald-600" /> Making…</> : <>{v.clips} clip{v.clips === 1 ? "" : "s"} · {secs(v.length)}</>}
        {v.exported && !v.busy && <CheckCircle2 size={10} className="text-emerald-600" />}
      </span>
    </span>
  </button>
);

export const VideoLibrary = ({ list, sel, onSelect }) => (
  <aside className="md:w-60 shrink-0 border-b md:border-b-0 md:border-r border-slate-200 bg-slate-50/80 flex flex-col" data-testid="video-library">
    <div className="px-3 py-2.5 flex items-center justify-between text-[10px] font-mono uppercase tracking-wider text-slate-500">
      My videos <span data-testid="video-lib-count">{list.length}</span>
    </div>
    <div className="flex md:flex-col gap-1 overflow-x-auto md:overflow-y-auto thin-scroll px-2 pb-2 md:flex-1">
      <button onClick={() => onSelect("new")} data-testid="video-new-btn"
        className={`shrink-0 md:w-full h-9 px-3 rounded-lg text-xs font-medium flex items-center gap-1.5 transition-colors ${sel === "new" ? "bg-emerald-600 text-white" : "bg-white border border-slate-200 text-slate-700 hover:border-emerald-400"}`}>
        <Plus size={13} /> New video
      </button>
      {list.map((v) => <Item key={v.id} v={v} active={sel === v.id} onClick={() => onSelect(v.id)} />)}
      {!list.length && <p className="hidden md:block px-2 py-2 text-[11px] text-slate-400" data-testid="video-lib-empty">Your videos will be saved here.</p>}
    </div>
  </aside>
);

export default VideoLibrary;
